import React from "react";
import { FaGraduationCap, FaFlask, FaPills, FaQuoteLeft, FaArrowRight, FaCalendarAlt, FaExternalLinkAlt, FaCheckCircle, FaStar, FaAward } from "react-icons/fa";
import { IoMdSchool } from "react-icons/io";
import { MdChair, MdVerified } from "react-icons/md";
import { GiChemicalDrop, GiMedicalPack } from "react-icons/gi";
import { BiCertification } from "react-icons/bi";

const AdmissionSection = () => {
  const admissionCards = [
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-red-100 to-slate-100">
     <div className="max-w-7xl mx-auto">
        {/* Admission Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {admissionCards.map((card, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden border border-gray-100"
            >
              {/* Card Header */}
              <div className={`bg-gradient-to-r ${card.color} p-5 text-white relative`}>
                <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-bl-3xl"></div>
                
                <div className="relative flex items-center gap-3">
                  <div className="bg-white/20 p-2.5 rounded-xl">
                    {card.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">{card.title}</h3>
                    <p className="text-xs text-white/90 mt-0.5">{card.qualification}</p>
                  </div>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-5">
                {/* Date */}
                <div className="flex items-center justify-center mb-4">
                  <div className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full">
                    <FaCalendarAlt className="text-blue-600 text-sm" />
                    <span className="text-xl font-bold text-gray-800">{card.date}</span>
                    <span className="text-gray-600 font-medium">{card.month}</span>
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-600 text-center mb-4 leading-relaxed">
                  {card.description}
                </p>

                {/* Program Highlights */}
                <div className="flex flex-wrap justify-center gap-2 mb-4">
                  {card.highlights.map((item, idx) => (
                    <span key={idx} className="bg-gray-100 text-gray-700 text-xs px-3 py-1.5 rounded-full">
                      {item}
                    </span>
                  ))}
                </div>

                {/* Admission Type */}
                <div className={`bg-gradient-to-r ${card.lightColor} p-3 rounded-xl mb-4`}>
                  <p className="text-sm font-semibold text-gray-700 text-center">
                    {card.type}
                  </p>
                </div>

                {/* Website Link */}
                <div className="text-center mb-4">
                  <p className="text-xs text-gray-500 mb-1">{card.loginText}</p>
                  <div className="flex items-center justify-center gap-1">
                    <FaExternalLinkAlt className="text-blue-600 text-xs" />
                    <a 
                      href={`https://${card.website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm font-medium text-blue-700 hover:text-blue-900 hover:underline"
                    >
                      {card.website}
                    </a>
                  </div>
                </div>

                {/* Apply Button */}
                <button className="w-full py-3 px-4 bg-gradient-to-r from-gray-800 to-gray-900 text-white font-medium rounded-xl hover:from-gray-900 hover:to-black transition-all duration-300 flex items-center justify-center gap-2">
                  Apply Online <FaArrowRight className="text-sm" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Chairman's Message Section - With Pencil Shadow Below Image */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200 mb-8">
          <div className="flex flex-col lg:flex-row">
            
            {/* Image Side - With pencil shadow */}
            <div className="lg:w-2/5 bg-white p-6 flex items-center justify-center">
              <div className="w-full max-w-sm">
                {/* Image with pencil-type shadow */}
                <div className="relative">
                  {/* Pencil shadow effect */}
                  <div className="absolute -bottom-3 left-5 right-5 h-4 bg-gray-300/50 blur-sm rounded-full"></div>
                  <div className="absolute -bottom-2 left-3 right-3 h-3 bg-gray-400/30 blur-md rounded-full"></div>
                  
                  {/* Main image */}
                  <img 
                    src="chairman.png" 
                    alt="Sandeep Singh, Chairman"
                    className="w-full h-auto block relative z-10"
                  />
                </div>
                
                {/* Name below photo */}
                <div className="mt-5 text-center">
                  <p className="text-gray-800 font-bold text-lg">Sandeep Singh</p>
                  <p className="text-gray-600 text-sm">Chairman</p>
                  <p className="text-red-600 text-sm">RDS Group Of College</p>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="lg:w-3/5 p-8 lg:p-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-blue-100 rounded-xl">
                  <MdChair className="text-2xl text-blue-700" />
                </div>
                <h2 className="text-2xl font-bold text-gray-800">
                  Chairman's Message
                </h2>
              </div>

              <div className="space-y-4 mb-6 text-gray-700">
                <p className="leading-relaxed">
                  The fast changing business environment is reshaping the mindset of modern professionals. 
                  Today, the ambition isn't just to lead in domestic markets — it's to make a mark on the 
                  global stage and tap into unexplored international potential.
                </p>
                
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-5 rounded-xl border-l-4 border-blue-600 italic">
                  "The risks are high, but so are the rewards. The future promises to be even more 
                  challenging, and we must prepare our students to not just face it, but to shape it."
                </div>
                
                <p>
                  A professional today must be agile, globally aware, and ready to leverage skills across 
                  borders. At Innovative Institute, we don't just teach subjects — we build visionaries. 
                </p>
              </div>

              {/* Stats and Button */}
              <div className="flex flex-wrap items-center justify-between gap-4">
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-green-600 text-white font-medium rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300">
                  <span>Read Full Message</span>
                  <FaArrowRight className="text-sm" />
                </button>

                <div className="flex gap-6">
                  <div className="text-center">
                    <span className="block text-xl font-bold text-gray-800">25+</span>
                    <span className="text-xs text-gray-500">Years</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-xl font-bold text-gray-800">15k+</span>
                    <span className="text-xs text-gray-500">Alumni</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-xl font-bold text-gray-800">100%</span>
                    <span className="text-xs text-gray-500">Placement</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Dates Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-xl p-5 text-white text-center shadow-lg">
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2">
              <FaCalendarAlt className="text-white text-lg" />
              <span className="font-medium">All admissions begin on <strong>12th June 2025</strong></span>
            </div>
            <span className="text-white/50 hidden sm:inline">|</span>
            <a href="#" className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-lg hover:bg-white/30 transition-colors">
              <span>Download Brochure</span>
              <FaArrowRight className="text-sm" />
            </a>
          </div>
        </div>

        {/* Quick Info Bar */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="bg-white rounded-lg p-3 flex items-center gap-3 shadow-sm">
            <BiCertification className="text-blue-600 text-xl" />
            <div>
              <p className="text-sm font-semibold text-gray-800">Government Approved</p>
              <p className="text-xs text-gray-500">All programs are UGC recognized</p>
            </div>
          </div>
          <div className="bg-white rounded-lg p-3 flex items-center gap-3 shadow-sm">
            <MdVerified className="text-green-600 text-xl" />
            <div>
              <p className="text-sm font-semibold text-gray-800">Merit Scholarships</p>
              <p className="text-xs text-gray-500">Up to 100% for deserving students</p>
            </div>
          </div>
          <div className="bg-white rounded-lg p-3 flex items-center gap-3 shadow-sm">
            <FaStar className="text-blue-600 text-xl" />
            <div>
              <p className="text-sm font-semibold text-gray-800">Limited Seats</p>
              <p className="text-xs text-gray-500">Apply before June 30th, 2025</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdmissionSection;